import FormatAlignCenterOutlinedIcon from "@mui/icons-material/FormatAlignCenterOutlined";
import FormatAlignLeftOutlinedIcon from "@mui/icons-material/FormatAlignLeftOutlined";
import FormatAlignRightOutlinedIcon from "@mui/icons-material/FormatAlignRightOutlined";
import { ListItemText, MenuItem, ToggleButton, ToggleButtonGroup } from "@mui/material";
import type { GridAlignment, GridColDef, GridColumnMenuItemProps } from "@mui/x-data-grid-premium";
const autoAlignment = "auto";

const alignmentToggleSx = {
  "& .MuiToggleButton-root.Mui-selected": {
    color: "primary.main",
    borderColor: "primary.main",
  },
};

interface Props extends GridColumnMenuItemProps {
  alignment: GridAlignment | undefined;
  onSetAlignment: (column: GridColDef, align: GridAlignment | undefined) => void;
}

const ColumnMenuAlignmentItem = ({ colDef, alignment, onSetAlignment }: Props) => (
  <MenuItem disableRipple sx={{ gap: 1, "&:hover": { bgcolor: "transparent" } }}>
    <ListItemText>Align</ListItemText>
    <ToggleButtonGroup
      exclusive
      size="small"
      value={alignment ?? autoAlignment}
      onChange={(_, value: GridAlignment | typeof autoAlignment | null) => {
        if (value !== null) {
          onSetAlignment(colDef, value === autoAlignment ? undefined : value);
        }
      }}
      aria-label="Column alignment"
      sx={alignmentToggleSx}
    >
      <ToggleButton value={autoAlignment} aria-label="Automatic alignment">
        Auto
      </ToggleButton>
      <ToggleButton value="left" aria-label="Align left">
        <FormatAlignLeftOutlinedIcon fontSize="small" />
      </ToggleButton>
      <ToggleButton value="center" aria-label="Align center">
        <FormatAlignCenterOutlinedIcon fontSize="small" />
      </ToggleButton>
      <ToggleButton value="right" aria-label="Align right">
        <FormatAlignRightOutlinedIcon fontSize="small" />
      </ToggleButton>
    </ToggleButtonGroup>
  </MenuItem>
);

export default ColumnMenuAlignmentItem;
